<script lang="ts" setup>
import { ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from 'lucide-vue-next'
const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    backgroundColor?: boolean
    currentPage?: number
    lastPage?: number
    total?: number
    pageSize?: number
    previousLabel?: string
    nextLabel?: string
    hasNextPage?: boolean
    hasPrevPage?: boolean
  }>(),
  {
    backgroundColor: true,
    currentPage: 1,
    lastPage: 1,
    total: 1,
    pageSize: 15,
    previousLabel: null,
    nextLabel: null,
    hasNextPage: false,
    hasPrevPage: false
  }
)

const emit = defineEmits<{
  (e: 'update:changePage', page: number): void
}>()

const isSimpleMode = computed(() => {
  return !props.total && (props.hasNextPage || props.hasPrevPage)
})

const totalRecords = computed(() => {
  if (isSimpleMode.value) {
    return props.currentPage * props.pageSize + (props.hasNextPage ? props.pageSize : 0)
  }
  return props.total || 0
})

const onPageChange = (newPage: number) => {
  emit('update:changePage', newPage)
}
</script>

<template>
  <div class="p-4">
    <Pagination
      :total="totalRecords"
      :items-per-page="pageSize"
      :sibling-count="1"
      :page="currentPage"
      show-edges
      @update:page="onPageChange"
    >
      <PaginationContent v-slot="{ items }">
        <PaginationFirst>
          <ChevronsLeftIcon />
          <span class="hidden sm:block">{{ t('global.pagination.first') }}</span>
        </PaginationFirst>
        <PaginationPrevious>
          <ChevronLeftIcon />
          <span class="hidden sm:block">{{ t('global.pagination.previous') }}</span>
        </PaginationPrevious>

        <template v-for="(item, index) in items" :key="index">
          <PaginationItem v-if="item.type === 'page'" :value="item.value" :is-active="item.value === currentPage">
            {{ item.value }}
          </PaginationItem>
          <PaginationEllipsis v-else :index="index" />
        </template>

        <PaginationNext>
          <span class="hidden sm:block">{{ t('global.pagination.next') }}</span>
          <ChevronRightIcon />
        </PaginationNext>
        <PaginationLast v-if="!isSimpleMode">
          <span class="hidden sm:block">{{ t('global.pagination.last') }}</span>
          <ChevronsRightIcon />
        </PaginationLast>
      </PaginationContent>
    </Pagination>
  </div>
</template>
